// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"304":"careers","462":"legal","884":"admin"}[chunkId] + "." + {"304":"2345cac4","462":"187a96c8","884":"0551d087"}[chunkId] + ".chunk.css";
};